import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"



type Props = {
  tileValue: string;
  isValidMove: boolean;
  location: number[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'GridTileView',
  props: {
    tileValue: null,
    isValidMove: { type: Boolean },
    location: null
  },
  emits: ["tilePressed"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  tileValue: string;
  isValidMove: boolean;
  location: number[];
};




function tilePressedACB() {
  emits("tilePressed", props.location);
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(_component_v_col, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(__props.isValidMove ? 'validMove' : ''),
        onClick: tilePressedACB
      }, [
        _createVNode(_component_v_img, {
          class: "clickable",
          src: 
          {
            k: require('../../assets/white_king.png'),
            d: require('../../assets/white.png'),
            a: require('../../assets/black.png'),
          }[__props.tileValue]
        
        }, null, 8, ["src"])
      ], 2)
    ]),
    _: 1
  }))
}
}

})